import memes from '../../../../memes';
import { format, isAfter, max, min } from 'date-fns';
import { getDateWithoutTimezone } from '../../../../Engine/components/FastSearch/utils';
import { SegmentSearchParameter } from '@websky/graphql';

export const isFlightsDatesInRightOrder = memes(
	(prev: boolean, curr: SegmentSearchParameter, index: number, segments: SegmentSearchParameter[]) => {
		const currentSegment = segments[index];
		const nextSegment = segments[index + 1];

		if (nextSegment && !prev) {
			const currentSegmentDate = new Date(currentSegment.date);
			const nextSegmentDate = new Date(nextSegment.date);

			return isAfter(currentSegmentDate, nextSegmentDate);
		}

		return prev;
	}
);

export const isWrongOrder = (segments: SegmentSearchParameter[], reduceRight: boolean = false): boolean =>
	reduceRight
		? segments.reduceRight(isFlightsDatesInRightOrder, false)
		: segments.reduce(isFlightsDatesInRightOrder, false);

export const sortSegments = memes(
	(legId: number, date: Date, segments: SegmentSearchParameter[]): SegmentSearchParameter[] => {
		const segmentsCopy = [...segments];
		const DATE_FORMAT = 'yyyy-MM-dd';

		if (legId === 0 && isWrongOrder(segmentsCopy)) {
			const maxDate = max(segmentsCopy.map(segment => getDateWithoutTimezone(segment.date)));

			segmentsCopy.forEach(segment => {
				segment.date = format(maxDate, DATE_FORMAT);
			});
		} else if (legId > 0 && isWrongOrder(segmentsCopy, true)) {
			const minDate = min([...segmentsCopy.map(segment => getDateWithoutTimezone(segment.date)), date]);

			segmentsCopy.forEach(segment => {
				segment.date = format(minDate, DATE_FORMAT);
			});
		}

		return segmentsCopy;
	}
);
